var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOffercat7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 48,
    viewBox: "0 0 39 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4906 1.42513C19.5656 1.86575 21 10.2845 21 13.5001C21 18.4032 18.3938 21.9001 14.5406 23.3063L15.75 45.6281C15.8156 46.9125 14.7937 48 13.5 48H7.5C6.21562 48 5.18437 46.9219 5.25 45.6281L6.45938 23.3063C2.59688 21.9001 0 18.3938 0 13.5001C0 10.2751 1.43438 1.86575 1.50938 1.42513C1.80938 -0.47799 5.75625 -0.506115 6 1.52825V14.7657C6.12187 15.0845 7.41563 15.0657 7.5 14.7657C7.63125 12.3939 8.24063 1.71575 8.25 1.47201C8.55937 -0.47799 12.4406 -0.47799 12.7406 1.47201C12.7594 1.72513 13.3594 12.3939 13.4906 14.7657C13.575 15.0657 14.8781 15.0845 14.9906 14.7657V1.52825C15.2344 -0.49674 19.1906 -0.47799 19.4906 1.42513ZM30.6656 28.2094L29.2594 45.5625C29.1469 46.875 30.1875 48 31.5 48H36.75C37.9969 48 39 46.9969 39 45.75V2.25013C39 1.01263 37.9969 0.000133992 36.75 0.000133992C29.0156 0.000133992 15.9938 16.7345 30.6656 28.2094Z",
    fill: "#CB202D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffercat7);
export default __webpack_public_path__ + "static/media/offercat7.39364d97b3dd792b76466277b8b7e2dc.svg";
export { ForwardRef as ReactComponent };